export default "__VITE_ASSET__BAC9AOae__"